import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result } from '@digibricks/domains';
import { ErrorResultHandler } from '@lib/domain-common';
import { AxiosApi } from '@digibricks/plugin-axios';
import { ParticipatedAssignmentResponder } from '../../../core';
export var PARTICIPATED_ASSIGNMENT_API = 'PARTICIPATED_ASSIGNMENT_API';
export var ParticipatedAssignmentApi = /*#__PURE__*/function (_AxiosApi) {
  _inherits(ParticipatedAssignmentApi, _AxiosApi);

  var _super = _createSuper(ParticipatedAssignmentApi);

  function ParticipatedAssignmentApi(axiosInstance) {
    var _this;

    _classCallCheck(this, ParticipatedAssignmentApi);

    _this = _super.call(this, 'assignments', axiosInstance);
    _this.axiosInstance = axiosInstance;
    return _this;
  }

  _createClass(ParticipatedAssignmentApi, [{
    key: "getParticipatedAssignment",
    value: function () {
      var _getParticipatedAssignment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(queryParams) {
        var url, jsonResponse, parsedResponseBody, responses;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                url = "".concat(this.url, "/participated");
                _context.next = 4;
                return this.axios.get(url, {
                  headers: {
                    Authorization: "Bearer ".concat(localStorage.getItem('access_token'))
                  },
                  params: queryParams
                });

              case 4:
                jsonResponse = _context.sent;
                parsedResponseBody = jsonResponse.data;

                if (parsedResponseBody.data) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt("return", Result.fail(parsedResponseBody.message));

              case 8:
                responses = parsedResponseBody.data.map(function (data) {
                  return ParticipatedAssignmentResponder.fromJson(data).getValue();
                });
                return _context.abrupt("return", Result.ok(responses));

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", ErrorResultHandler(_context.t0));

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 12]]);
      }));

      function getParticipatedAssignment(_x) {
        return _getParticipatedAssignment.apply(this, arguments);
      }

      return getParticipatedAssignment;
    }()
  }]);

  return ParticipatedAssignmentApi;
}(AxiosApi);